/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Styled components
 */
export default styled.div`
  align-items: center;
  background-color: rgba(231, 76, 60, 0.5);
  display: flex;
  font-size: ${scale.major(2)}px;
  font-weight: bold;
  height: ${scale.major(5)}px;
  justify-content: center;
  width: 100%;
`;
